import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';

export interface OverlapEventItem {
  /** Unique across sources — see the calendars' own CalEvent.key. */
  key: string;
  id: number;
  title: string;
  startHour: number;
  startMinute: number;
  endHour: number;
  endMinute: number;
}

export interface OverlapEventsData {
  events: OverlapEventItem[];
}

@Component({
  selector: 'app-overlap-events',
  imports: [MatDialogModule, MatButtonModule, MatRippleModule],
  templateUrl: './overlap-events.html',
  styleUrl: './overlap-events.css',
})
export class OverlapEvents {
  private data = inject<OverlapEventsData>(MAT_DIALOG_DATA);
  private ref = inject(MatDialogRef<OverlapEvents>);
  events = this.data.events;

  select(event: OverlapEventItem): void {
    this.ref.close(event);
  }

  close(): void {
    this.ref.close();
  }

  timeLabel(hour: number, minute: number): string {
    const period = hour >= 12 ? 'pm' : 'am';
    const h = hour % 12 || 12;
    const m = minute.toString().padStart(2, '0');
    return minute === 0 ? `${h}${period}` : `${h}:${m}${period}`;
  }
}
